var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.927 14.059a.537.537 0 01.526-.548h.007c.3.002.542.246.54.547v5.386a.55.55 0 01-.54.556H.533A.544.544 0 010 19.445v-5.386a.537.537 0 01.526-.548h.007c.3.002.542.246.54.547v4.838h17.854V14.06zM4.85 5.067a.56.56 0 000 .782.514.514 0 00.726.027l.027-.027L9.46 1.89v13.087a.544.544 0 00.532.556.55.55 0 00.541-.556V1.888l3.851 3.961c.198.21.529.22.74.022l.02-.022a.56.56 0 000-.782L10.375.159a.535.535 0 00-.758-.004l-.004.004L4.85 5.067z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgUpload;